import produce from 'immer'
import { assign } from 'lodash'

import { FETCH_AWARD, UPDATE_AWARD_SIMPLE_DETAILS } from '../action-types'
import { AWARD_INITIAL_STATE } from '../initial-states'

const awardReducer = (state = AWARD_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_AWARD.START:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: true,
          fetchError: undefined,
          data: [],
        }),
      )

    case FETCH_AWARD.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: undefined,
          data: action.payload.data.award,
        }),
      )

    case FETCH_AWARD.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isFetchLoading: false,
          fetchError: action.error.message,
          data: [],
        }),
      )

    case FETCH_AWARD.CLEANUP:
      return { ...AWARD_INITIAL_STATE }

    case UPDATE_AWARD_SIMPLE_DETAILS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: true,
          simpleDetailsError: undefined,
        }),
      )

    case UPDATE_AWARD_SIMPLE_DETAILS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: undefined,
          data: assign(
            nextState.data,
            action.payload.data.updateAwardSimpleDetails,
          ),
        }),
      )

    case UPDATE_AWARD_SIMPLE_DETAILS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isSimpleDetailsLoading: false,
          simpleDetailsError: action.error.message,
        }),
      )

    default:
      return state
  }
}

export default awardReducer
